(function () {
    'use strict';
    eoNumericInputTestController.$inject = ['$scope', '$attrs', '$element'];

    function eoNumericInputTestController($scope, $attrs, $element) {
        var $ctrl = this;
        $ctrl.inputValueCurrency = $ctrl.inputValue


        $scope.$watch($ctrl.formReference.$invalid, function (invalid) {
            //this code check the form errors
            // DO NOT DELETE THIS !!!!
        })
        handleChanges();

        $ctrl.onValueChange = handleChanges;
        function handleChanges() {
            replaceIosNumbers();
            replaceAndroidNumbers();
            removeInvalidCharacter();
            if($ctrl.currencyFormat){
                currencyFormat()
            }
            if ($ctrl.onChange)
                $ctrl.onChange();
        }

        $ctrl.getClass = function () {
            return $ctrl.customClass;
        }


        function replaceIosNumbers() {
            if (!$ctrl.inputValueCurrency)
                return;
            var corrected = $ctrl.inputValueCurrency;
            for (var i = 0; i < $ctrl.inputValueCurrency.length; i++) {
                var charCode = $ctrl.inputValueCurrency.charCodeAt(i);
                if (charCode == 1632)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "0");
                if (charCode == 1633)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "1");
                if (charCode == 1634)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "2");
                if (charCode == 1635)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "3");
                if (charCode == 1636)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "4");
                if (charCode == 1637)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "5");
                if (charCode == 1638)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "6");
                if (charCode == 1639)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "7");
                if (charCode == 1640)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "8");
                if (charCode == 1641)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "9");


            }
            $ctrl.inputValueCurrency = corrected;
        }

        function replaceAndroidNumbers() {
            if (!$ctrl.inputValueCurrency)
                return;
            var corrected = $ctrl.inputValueCurrency;
            for (var i = 0; i < $ctrl.inputValueCurrency.length; i++) {
                var charCode = $ctrl.inputValueCurrency.charCodeAt(i);
                if (charCode == 1776)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "0");
                if (charCode == 1777)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "1");
                if (charCode == 1778)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "2");
                if (charCode == 1779)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "3");
                if (charCode == 1780)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "4");
                if (charCode == 1781)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "5");
                if (charCode == 1782)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "6");
                if (charCode == 1783)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "7");
                if (charCode == 1784)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "8");
                if (charCode == 1785)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "9");


            }
            $ctrl.inputValueCurrency = corrected;
        }

        function isValidNumber(char) {

            if (char == '0'
                || char == '1'
                || char == '2'
                || char == '3'
                || char == '4'
                || char == '5'
                || char == '6'
                || char == '7'
                || char == '8'
                || char == '9'
            )
                return true;

            return false;

        }

        function removeInvalidCharacter() {
            if (!$ctrl.inputValueCurrency)
                return;
            var corrected = $ctrl.inputValueCurrency;
            for (var i = 0; i < $ctrl.inputValueCurrency.length; i++) {
                var ccc = $ctrl.inputValueCurrency.charCodeAt(i);
                if (!isValidNumber($ctrl.inputValueCurrency.charAt(i))) {
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), '');
                }
            }

            $ctrl.inputValueCurrency = corrected;
            $ctrl.inputValue = corrected

        }

        function currencyFormat() {
            // var res = new Intl.NumberFormat('fa-IR', {
            //     style: 'currency',
            //     currency: "IRR",
            //      minimumFractionDigits: 0,
            //     maximumFractionDigits: 0
            // }).format($ctrl.inputValueCurrency)
            // $ctrl.inputValueCurrency = res.replaceAll('ریال','').replaceAll('٬',',')
            if (!$ctrl.inputValueCurrency) return;

            var num = String($ctrl.inputValueCurrency).replace(/[^\d]/g, "");

            num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            $ctrl.inputValueCurrency = num;
        }

    }

    var eo_NumericInput = {

        templateUrl: 'app/components/eyeson/numeric-input/eyeson.numeric-input-v2.template.html',
        controller: eoNumericInputTestController,
        bindings: {
            name: '@',
            inputValue: "=",
            customClass: "@",
            isDisabled: "=?",
            isRequired: "=?",
            formReference: '<',
            min: '@',
            max: '@',
            maxlength: "=?",
            minlength: '@',
            placeholder: '@',
            onChange: '=?',
            currencyFormat: "=?"

        }
    };
    angular
        .module('tikonApp')
        .component('eoNumericInputV2', eo_NumericInput);

})();